<template>
  <v-dialog v-model="popupData.user"  width="300" color="white">
    <v-card class="px-3 py-3">
      <v-card-text class="text-center py-3 px-0">
        <p class="mb-0 text-caption lh-20 color-7d7d7d">Mobile Number</p>
        <p class="black--text text-h6 lh-20 mb-1">
          {{ popupData.user.mobile || 'Unused' }}
        </p>
      </v-card-text>
      <hr />
      <v-card-text class="text-center py-3 px-0" :style="{'display':'flex', 'justify-content':'space-between'}">
        <div>
          <p class="mb-0 text-caption lh-20 color-7d7d7d">Date</p>
          <p class="black--text text-caption lh-20 mb-1">
            {{ dateFormat(popupData.user.planStartTime) }}
          </p>
        </div>
        <div>
          <p class="mb-0 text-caption lh-20 color-7d7d7d">Time</p>
          <p class="black--text text-caption lh-20 mb-1">
            {{ timeFromDatTime(popupData.user.planStartTime) }}
          </p>
        </div>
        <div>
          <p class="mb-0 text-caption lh-20 color-7d7d7d">Amount</p>
          <p class="black--text text-caption lh-20 mb-1">
            {{ "₹ " + popupData.user.charges }}
          </p>
        </div>
      </v-card-text>
      <hr />
      <v-card-text class="text-center py-3 px-0" :style="{'display':'flex', 'justify-content':'space-between'}">
        <div>
          <p class="mb-0 text-caption lh-20 color-7d7d7d">Plan</p>
          <p class="black--text text-caption lh-20 mb-1">
            {{popupData.user.dataLimit ? dataFormat(popupData.user.dataLimit * 1024 * 1024) : "NA"}}
            /
            {{popupData.user.timePlan ? timeFormat(popupData.user.timePlan) : "NA"}}
          </p>
        </div>
        <div>
          <p class="mb-0 text-caption lh-20 color-7d7d7d">Status</p>
          <p class="black--text text-caption lh-20 mb-1">
            <img :src="`https://i2e1components.s3.ap-south-1.amazonaws.com/wiom-dashboard/img/icons/${templateModel.status}.svg`" style="vertical-align:middle" />
            <span style="text-transform: capitalize;margin-left:.25rem;">{{templateModel.status}}</span>
          </p>
        </div>
        <div>
          <p class="mb-0 text-caption lh-20 color-7d7d7d">Medium</p>
          <p class="black--text text-caption lh-20 mb-1">
            <img src="~/img/icons/wallet.svg" style="vertical-align:middle" />
            <span style="text-transform: capitalize;margin-left:.25rem;" v-if="popupData.user.charges == 0">Free</span>
            <span style="text-transform: capitalize;margin-left:.25rem;" v-else>{{popupData.user.extraData.payment_mode || 'cash'}}</span>
          </p>
        </div>
      </v-card-text>
      <hr />
      <v-card-text class="text-center py-3 px-0" v-if="popupData.user.extraData.sent_to" :style="{'display':'flex', 'justify-content':'space-between'}">
        <div v-if="popupData.user.extraData.sent_to">
            <p class="mb-0 text-caption lh-20 color-7d7d7d">Sent to</p>
            <span style="text-transform: capitalize;margin-left:.25rem;">
              {{ popupData.user.extraData.sent_to }}
            </span>
        </div>
        <div>
            <p class="mb-0 text-caption lh-20 color-7d7d7d">Coupon code</p>
            <p class="text-h6 lh-20 mb-1" color="#ff7700">
              {{ popupData.user.otp }}
            </p>
        </div>
      </v-card-text>
      <hr v-if="popupData.type == myTypes.ISSUED_COUPON"/>
      <v-card-actions :style="{'display':'flex','justify-content':'space-around','padding': '1rem 1rem 0 1rem'}">
        <v-btn depressed outlined @click="buttons.GREY.action()" class="text-capitalize" :style="{'background': 'white'}"
          v-if="buttons.GREY">
          {{buttons.GREY.text}}
        </v-btn>
        <v-btn color="error" class="text-capitalize btn-gredient"  v-if="buttons.RED"
           @click="buttons.RED.action()">{{buttons.RED.text}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<style scoped lang="scss">

</style>

<script>
  import WIOM_APIS from '../../utils/wiom-apis';
  import helper from "../../utils/helper";
  export default {
    props: ["popupData", "selectedLocation"],
    data: function () {
      return {
        templateModel: {
          data: '',
          time: '',
          price: '',
          devices: '',
          dataUnit: "MB",
          timeUnit: "Min.",
          status:''
        },
        myTypes: {
          PENDING: 'pending',
          ISSUED_COUPON: 'issued-coupon',
          DONE: 'done'
        },
        buttons: {
          GREY: {
            action: this.close,
            text: 'Cancel'
          },
          RED: {
            action: this.close,
            text: 'Ok'
          }
        }
      }
    },
    mounted: function () {
      switch (this.popupData.type) {
        case this.myTypes.PENDING:
          this.templateModel.status = 'pending';
          this.buttons.GREY.text = 'Reject';
          this.buttons.RED.text = 'Allow';
          this.buttons.RED.action = this.authorizeUser;
          this.buttons.GREY.action = () => {
            //this.updateFDMUserStatus('rejected');
            let nasid = this.selectedLocation.nasid;
            let user = this.popupData.user;
            WIOM_APIS.authorizeUser(user.mobile, nasid, false).then((response) => {
              if (response.data) {
                this.$emit("refresh-registered-users");
                this.close();
              }
            });
            
            };
          break;
        case this.myTypes.ISSUED_COUPON:
          this.templateModel.status = 'pending';
          this.buttons.GREY.text = 'Delete';
          this.buttons.RED.text = 'OK';
          this.buttons.GREY.action = () => {this.updateFDMUserStatus('deleted')};
          break;
        case this.myTypes.DONE:
          var d = new Date();
          if(this.popupData.user.authState && this.popupData.user.otpExpiryTime < d) {
            this.templateModel.status = 'expired';
            this.buttons.GREY = null;
            this.buttons.RED.text = 'OK';
          } else if(this.popupData.user.authState && this.popupData.user.otpExpiryTime > d) {
            this.templateModel.status = 'active';
            this.buttons.GREY.text = 'Cancel';
            this.buttons.RED.text = 'Disconnect';
            this.buttons.RED.action = () => {this.updateFDMUserStatus('disconnected')};
          } else {
            this.templateModel.status = this.popupData.user.status;
            this.buttons.GREY = null;
            this.buttons.RED.text = 'Ok';
            this.buttons.RED.action = this.close;
          }
          
          break;
      }
    },
    methods: {
      close: function () {
        this.$emit("closed");
      },
      dataFormat: helper.dataFormat,
      timeFormat: helper.timeFormat,
      dateFormat: function (str) {
        let dateTime = new Date(str);
        return dateTime.toGMTString().substring(5, 16);
      },
      timeFromDatTime: function (str) {
        let dateTime = new Date(str);
        let time = dateTime.toTimeString();
        time = time.substr(0, time.lastIndexOf(":"));
        return time;
      },
      updateFDMUserStatus: function(status) {
        let user = this.popupData.user;
        user.status = status;
        delete user.extraData;
        WIOM_APIS.updateUser(user).then((response) => {
          if (response.data) {
            this.$emit("refresh-registered-users");
            this.close();
          }
        });
      },
      authorizeUser: function (user) {
        let nasid = this.selectedLocation.nasid;
        user = user || this.popupData.user;
        if (user.otp == 'PAY_ONLINE') {
          WIOM_APIS.upgradeUserPolicy(nasid, user.id, user.extraData.plan_id).then((response) => {
            if (response.data) {
               this.$emit("refresh-registered-users");
                this.close();
            }
          });
        } else {
          WIOM_APIS.authorizeUser(user.mobile, nasid).then((response) => {
            if (response.data) {
              this.$emit("refresh-registered-users");
              this.close();
            }
          });
        }
      }
    }
  }
</script>